module.exports = __webpack_public_path__ + "static/media/CustomersIconBlack.2586fa64.svg";